import ContactForm from '../../components/ContactForm/ContactForm.vue';

export default {
  props: {},

  components: {
    ContactForm,
  },

  beforeMount() {},

  mounted() {},

  data() {},

  computed: {},

  methods: {},

  beforeDestroy() {},

  watch: {},
};
